import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import PensumList from './PensumList';
import PensumForm from './PensumForm';
import DeletedPensumsList from './DeletedPensumsList';

const Pensums = () => {
  return (
    <Routes>
      <Route path="/" element={<PensumList />} />
      <Route path="/new" element={<PensumForm />} />
      <Route path="/:gradeId/edit" element={<PensumForm />} />
      <Route path="/deleted" element={<DeletedPensumsList />} />
      <Route path="*" element={<Navigate to="/pensums" replace />} />
    </Routes>
  );
};

export default Pensums;
